import { Component, Input } from '@angular/core';

import { statusPretendidoRealizado } from '../../cliente-analise-mercado-status-pretendido';
import { ClienteAnaliseMercadoStatusPretendidoPipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-pretendido-badge-pill-realizado',
    templateUrl: './cliente-analise-mercado-status-pretendido-badge-pill-realizado.component.html',
    styleUrls: ['./cliente-analise-mercado-status-pretendido-badge-pill-realizado.component.less']
})
export class ClienteAnaliseMercadoStatusPretendidoBadgePillRealizadoComponent {
    /** Title para exibir no badge */
    @Input() title: string = null;

    constructor(private clienteAnaliseMercadoStatusPretendidoPipe: ClienteAnaliseMercadoStatusPretendidoPipe) { }

    /** Retorna o title para exibir no badge */
    getTitle(): string {
        return this.title ? this.title : this.clienteAnaliseMercadoStatusPretendidoPipe.transform(statusPretendidoRealizado.id);
    }
}
